
class PaymentInstallmentTemplateCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;
    private paymentsLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.paymentsLabel = MUIOutlet(this, "payments-lbl", "MUILabel");
    }

    private _item:PaymentInstallmentTemplate = null;
    set item(item:PaymentInstallmentTemplate){
        this._item = item;

        this.nameLabel.text = item.name;
        let count = item.lines != null ? item.lines.count : 0;
        this.paymentsLabel.text = count + " " + MIOLocalizeString("PAYMENTS", "PAYMENTS");
    }
}
